import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getDashboardPayment = createAsyncThunk("dashPay/getData", async(periode) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const q = periode ? `?periode=${encodeURIComponent(periode)}` : '';
    const response = await jwtAuthAxios.get(`v1/dashboard/payment${q}`);
    return response.data;
});

export const getPaymentPerPeriode = createAsyncThunk("dashPay/perPeriode", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/payment/per-periode`);
    return response.data;
});

export const getPaymentByTipe = createAsyncThunk("dashPay/byTipe", async(periode) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const q = periode ? `?periode=${encodeURIComponent(periode)}` : '';
    const response = await jwtAuthAxios.get(`v1/dashboard/payment/by-tipe${q}`);
    return response.data;
});

const initialState = {
    loadingDashPayment : false,
    responseDashPayment : {},
    loadingPaymentPerPeriode : false,
    responsePaymentPerPeriode : { labels: [], data: [] },
    loadingPaymentByTipe : false,
    responsePaymentByTipe : { labels: [], data: [] },
}

const dashPaymentSlice = createSlice({
    name:"dashPaymentSlice",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardPayment.pending, (state) => {
                state.loadingDashPayment = true;
            })
            .addCase(getDashboardPayment.fulfilled, (state, action) => {
                state.responseDashPayment = action.payload;
                state.loadingDashPayment = false;
            })
            .addCase(getDashboardPayment.rejected, (state) => {
                state.loadingDashPayment = false;
            })
            .addCase(getPaymentPerPeriode.pending, (state) => {
                state.loadingPaymentPerPeriode = true;
            })
            .addCase(getPaymentPerPeriode.fulfilled, (state, action) => {
                state.responsePaymentPerPeriode = action.payload;
                state.loadingPaymentPerPeriode = false;
            })
            .addCase(getPaymentPerPeriode.rejected, (state) => {
                state.loadingPaymentPerPeriode = false;
            })
            .addCase(getPaymentByTipe.pending, (state) => {
                state.loadingPaymentByTipe = true;
            })
            .addCase(getPaymentByTipe.fulfilled, (state, action) => {
                state.responsePaymentByTipe = action.payload;
                state.loadingPaymentByTipe = false;
            })
            .addCase(getPaymentByTipe.rejected, (state) => {
                state.loadingPaymentByTipe = false;
            });
    }
})

export const dashPaymentSelector = (state) => state.dashPayment;
export default dashPaymentSlice.reducer;
